export default __webpack_public_path__ + "bf9d19a268023aa670df93d52c48964c.png";